import { call, put, takeLatest } from "redux-saga/effects";
import { GET_ScheduleWorkItems, GET_ScheduleCalendar, GET_ScheduleTimeline } from "../services/Schedule";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_ScheduleWorkItemsEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_ScheduleWorkItems, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ScheduleWorkItems", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_ScheduleCalendarEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_ScheduleCalendar, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ScheduleCalendar", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_ScheduleTimelineEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_ScheduleTimeline, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ScheduleTimeline", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_ScheduleWorkItems", GET_ScheduleWorkItemsEffect);
  yield takeLatest("GET_ScheduleCalendar", GET_ScheduleCalendarEffect);
  yield takeLatest("GET_ScheduleTimeline", GET_ScheduleTimelineEffect);
}
